"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganization = void 0;
const tslib_1 = require("tslib");
const swr_1 = tslib_1.__importDefault(require("swr"));
const IsomorphicClerkContext_1 = require("../contexts/IsomorphicClerkContext");
const OrganizationContext_1 = require("../contexts/OrganizationContext");
const SessionContext_1 = require("../contexts/SessionContext");
const useOrganization = ({ invitationList: invitationListParams, membershipList: membershipListParams, } = {}) => {
    const { organization, lastOrganizationMember, lastOrganizationInvitation } = (0, OrganizationContext_1.useOrganizationContext)();
    const session = (0, SessionContext_1.useSessionContext)();
    const isomorphicClerk = (0, IsomorphicClerkContext_1.useIsomorphicClerkContext)();
    // TODO re-iterate on SSR based on value of `organization`
    if (!isomorphicClerk.loaded || !session || !organization) {
        return {
            isLoaded: false,
            organization: undefined,
            invitationList: undefined,
            membershipList: undefined,
            membership: undefined,
        };
    }
    const clerk = isomorphicClerk;
    const pendingInvitations = async () => {
        var _a;
        return await ((_a = clerk.organization) === null || _a === void 0 ? void 0 : _a.getPendingInvitations(invitationListParams));
    };
    const currentOrganizationMemberships = async () => {
        var _a;
        return await ((_a = clerk.organization) === null || _a === void 0 ? void 0 : _a.getMemberships(membershipListParams));
    };
    const { data: invitationList, isValidating: isInvitationsLoading } = (0, swr_1.default)(invitationListParams
        ? composeOrganizationResourcesUpdateKey(organization, lastOrganizationInvitation, 'invitations')
        : null, pendingInvitations);
    const { data: membershipList, isValidating: isMembershipsLoading } = (0, swr_1.default)(membershipListParams
        ? composeOrganizationResourcesUpdateKey(organization, lastOrganizationMember, 'memberships')
        : null, currentOrganizationMemberships);
    return {
        isLoaded: !isMembershipsLoading && !isInvitationsLoading,
        organization,
        membershipList,
        membership: getCurrentOrganizationMembership(session.user.organizationMemberships, organization.id),
        invitationList,
    };
};
exports.useOrganization = useOrganization;
function getCurrentOrganizationMembership(organizationMemberships, activeOrganizationId) {
    return organizationMemberships.find(organizationMembership => organizationMembership.organization.id === activeOrganizationId);
}
function composeOrganizationResourcesUpdateKey(organization, resource = null, resourceType) {
    return `${organization.id}${resource === null || resource === void 0 ? void 0 : resource.id}${resource === null || resource === void 0 ? void 0 : resource.updatedAt}${resourceType}`;
}
//# sourceMappingURL=useOrganization.js.map